import { render, staticRenderFns } from "./CarregandoTipoPrestador.vue?vue&type=template&id=73d56830&scoped=true"
import script from "./CarregandoTipoPrestador.vue?vue&type=script&lang=js"
export * from "./CarregandoTipoPrestador.vue?vue&type=script&lang=js"
import style0 from "./CarregandoTipoPrestador.vue?vue&type=style&index=0&id=73d56830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d56830",
  null
  
)

export default component.exports